<template>
  <div id="app">
    <router-view/>
    <div class="loader">
      <div class="spinner" v-if="isLoading">
        <div class="double-bounce1"></div>
        <div class="double-bounce2"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'App',
  components: {
    'vue-toastr': window.vueToastr
  },
  computed: {
    ...mapGetters({
      isLoading: 'loader/isLoading'
    })
  },
  mounted () {
    this.$toastr.defaultPosition = 'toast-bottom-center'
    this.$toastr.defaultTimeout = 2500
    this.$toastr.defaultProgressBar = false
    this.$toastr.defaultPreventDuplicates = true
  }
}
</script>

<style lang="scss">
@import './assets/styles/index.scss';
#app {

}
</style>



// WEBPACK FOOTER //
// src/App.vue